<template>
    <ListeBonAncien/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
    import ListeBonAncien from "@/components/GesCom/BonAncien/ListeBonAncien.vue";
    export default defineComponent({
      name: "ListeBonAncienPage",
      components: {
        ListeBonAncien,
      },
    });
  </script>